<template>
  <div class="header">
    <div class="left">
      <div class="fold" @click="collapse">
        <span class="trigger el-icon-s-fold" :class="isCollapse ? '' : 'isCollapse'">
        </span>
      </div>
      <div class="title">
        <span class="CN">{{
          $t('login.login_title') }}
        </span>
        <span class="EN">Construction Industry Association Work System</span>
      </div>
    </div>
    <div class="right">
      <el-dropdown @command="handleCommand" placement="top">
        <div class="menus">
          <span class="el-dropdown-link">
            <img src="../../../../../static/img/userIcon.png" alt="">
            <span class="userName">{{ userName }}</span>
          </span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="personalCenter">{{ $t('layout.personalCenter') }}</el-dropdown-item>
          <el-dropdown-item command="exit">{{ $t('layout.exit') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { nextTick } from 'vue';

export default {
  name: "Header",
  data() {
    return {
      isCollapse: false,
      userName: '',
    };
  },
  created() {
    this.query();
  },
  methods: {
    collapse() {
      this.isCollapse = !this.isCollapse
      this.$store.dispatch("collapse");
    },
    //获取用户名
    query() {
      let storage = window.sessionStorage;
      this.userName = storage.getItem("userName");
    },

    //点击下拉菜单
    handleCommand(command) {
      if (command == 'personalCenter') {
        this.personalCenter();
      } else {
        this.exit();
      }
    },
    personalCenter() {
      this.$router.push({
        path: "/personal"
      });
    },
    exit() {
      let storage = window.sessionStorage;
      this.$message({
        showClose: true,
        message: "success,退出成功",
        type: "success",
        duration: 2000
      });
      this.$store.dispatch("setToken", "");
      this.$store.dispatch("removeOtherTab", {
        all: true,
        router: this.$router
      });
      // localStorage.clear();
      Cookies.remove("token");
      Cookies.remove("userName");
      Cookies.remove("userType");
      storage.clear();
      this.$router.push({
        path: "/login"
      });
      // window.location.reload();
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;

  .left {
    width: 40%;
    height: 100%;
    display: flex;

    .fold {
      width: 65px !important;
      height: 100%;
      font-size: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #4d83b9;
      color: #ffff;
      cursor: pointer;

      .trigger {
        transition: all .3s;
        transform: rotate(180deg);
      }

      .isCollapse {
        transform: rotate(0deg);
      }
    }

    .title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-left: 20px;

      .CN {
        color: #ffff;
        font-size: 23px;
      }

      .EN {
        color: #ffff;
        font-size: 5px;
      }
    }

  }

  .right {
    width: 40%;
    height: 100%;

    .el-dropdown {
      float: right;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;

      .menus {
        width: 100%;
        height: 100%;

        .el-dropdown-link {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: end;
          align-items: center;
          cursor: pointer;

          img {
            width: 23px;
            margin-right: 5px;
            margin-left: 10px;
          }

          .userName {
            color: #ffff;
            font-size: 17px;
            margin-right: 10px;
          }
        }
      }

      /deep/ .menus :hover {
        background-color: #4d83b9 !important;
      }

      /deep/ .el-dropdown-menu {
        margin-top: 58px !important;
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/system/index/layout/header/header.vue